const value = Object.freeze({
  IntercambioEscuela: 45,
  InventarioEscuela: 46,
  IntercambioCentro: 93,
  InventarioCentro: 454
});
export default value;
